import { DtoBase } from "../DtoBase";
import { List } from "../../DiscoveryEngine.TS/Utils/List";
import { ObjSerUtils } from "../../DiscoveryEngine.TS/Serialization/ObjSerUtils";
import { ValueEncoder } from "../../DiscoveryEngine.TS/Utils/ValueEncoder";
import { ViewerDeviceGroupContainerGUIDs } from '../Viewer/ViewerDeviceGroupTreeDto';


export class DisplayDeviceGroupDto extends DtoBase {
	public Owner: string;
	public Name: string;
	public DeviceCount: number;
	public VdgGuid: string;
	public VdgTagGuid: string;
	public ChildGroups: List<DisplayDeviceGroupDto>;

	constructor() {
		super();
		this.Owner = "";
		this.Name = "";
		this.DeviceCount = 0;
		this.VdgGuid = "";
		this.VdgTagGuid = "";
		this.ChildGroups = new List<DisplayDeviceGroupDto>();
	}

	public get HasChildGroups(): boolean {
		return !!this.ChildGroups && this.ChildGroups.Count > 0;
	}

	public Write(obj: any, context: any): void {
		obj.display_device_group = {};
		obj = obj.display_device_group;

		super.Write(obj, context);

		if (this.Owner) {
			obj.owner = this.Owner;
		}
		if (this.Name) {
			obj.name = this.Name;
		}
		if (this.DeviceCount > 0) {
			obj.device_count = ValueEncoder.EncodeInteger(this.DeviceCount);
		}
		if (this.VdgGuid) {
			obj.vdg_guid = this.VdgGuid;
		}
		if (this.VdgTagGuid) {
			obj.vdg_tag_guid = this.VdgTagGuid;
		}
		if (this.ChildGroups && this.ChildGroups.Count > 0) {
			obj.child_groups = [];
			ObjSerUtils.WriteObjSerCollection(obj.child_groups, this.ChildGroups, context);
		}
	}

	public Read(obj: any, context: any): void {

		if (!obj.display_device_group)
			throw new Error();
		obj = obj.display_device_group;

		super.Read(obj, context);

		if (obj.owner !== undefined) {
			this.Owner = obj.owner;
		}
		if (obj.name !== undefined) {
			this.Name = obj.name;
		}
		if (obj.device_count !== undefined) {
			this.DeviceCount = ValueEncoder.DecodeInteger(obj.device_count);
		}
		if (obj.vdg_guid !== undefined) {
			this.VdgGuid = obj.vdg_guid;
		}
		if (obj.vdg_tag_guid !== undefined) {
			this.VdgTagGuid = obj.vdg_tag_guid;
		}
		if (obj.child_groups !== undefined) {
			this.ChildGroups.Clear();
			ObjSerUtils.ReadObjSerCollection(obj.child_groups, this.ChildGroups, (value: any) => {
				return new DisplayDeviceGroupDto();
			}, context);
		}
	}
}


export class DisplayDeviceGroupContainerDto extends DtoBase {
	public Owner: string;
	public Name: string;
	public VdgcGuid: string;
	public VdgcTagGuid: string;
	public Containers: List<DisplayDeviceGroupContainerDto>;
	public Groups: List<DisplayDeviceGroupDto>;

	constructor() {
		super();
		this.Owner = "";
		this.Name = "";
		this.VdgcGuid = "";
		this.VdgcTagGuid = "";
		this.Containers = new List<DisplayDeviceGroupContainerDto>();
		this.Groups = new List<DisplayDeviceGroupDto>();
	}

	public Write(obj: any, context: any): void {
		obj.display_device_group_container = {};
		obj = obj.display_device_group_container;

		super.Write(obj, context);

		if (this.Owner) {
			obj.owner = this.Owner;
		}
		if (this.Name) {
			obj.name = this.Name;
		}
		if (this.VdgcGuid) {
			obj.vdgc_guid = this.VdgcGuid;
		}
		if (this.VdgcTagGuid) {
			obj.vdgc_tag_guid = this.VdgcTagGuid;
		}
		if (this.Containers && this.Containers.Count > 0) {
			obj.containers = [];
			ObjSerUtils.WriteObjSerCollection(obj.containers, this.Containers, context);
		}
		if (this.Groups && this.Groups.Count > 0) {
			obj.groups = [];
			ObjSerUtils.WriteObjSerCollection(obj.groups, this.Groups, context);
		}
	}

	public Read(obj: any, context: any): void {

		if (!obj.display_device_group_container)
			throw new Error();
		obj = obj.display_device_group_container;

		super.Read(obj, context);

		if (obj.owner !== undefined) {
			this.Owner = obj.owner;
		}
		if (obj.name !== undefined) {
			this.Name = obj.name;
		}
		if (obj.vdgc_guid !== undefined) {
			this.VdgcGuid = obj.vdgc_guid;
		}
		if (obj.vdgc_tag_guid !== undefined) {
			this.VdgcTagGuid = obj.vdgc_tag_guid;
		}
		if (obj.containers !== undefined) {
			this.Containers.Clear();
			ObjSerUtils.ReadObjSerCollection(obj.containers, this.Containers, (value: any) => {
				return new DisplayDeviceGroupContainerDto();
			}, context);
		}
		if (obj.groups !== undefined) {
			this.Groups.Clear();
			ObjSerUtils.ReadObjSerCollection(obj.groups, this.Groups, (value: any) => {
				return new DisplayDeviceGroupDto();
			}, context);
		}
	}
};


export class DisplayDeviceGroupTreeDto extends DtoBase {
	public RootContainer: DisplayDeviceGroupContainerDto;

	constructor() {
		super();
		this.RootContainer = null;
	}

	public Write(obj: any, context: any): void {
		obj.display_device_group_tree = {};
		obj = obj.display_device_group_tree;

		super.Write(obj, context);

		if (this.RootContainer) {
			this.RootContainer.Write(obj, context);
		}
	}

	public Read(obj: any, context: any): void {

		if (!obj.display_device_group_tree)
			throw new Error();
		obj = obj.display_device_group_tree;

		super.Read(obj, context);

		if (obj.display_device_group_container !== undefined) {
			this.RootContainer = new DisplayDeviceGroupContainerDto();
			this.RootContainer.Read(obj, context);
		}
	}

	public get UserGroupsContainer(): DisplayDeviceGroupContainerDto {
		return this.FindContainerByTagGuid(ViewerDeviceGroupContainerGUIDs.UserGroups);
	}

	public get SubnetGroupsContainer(): DisplayDeviceGroupContainerDto {
		return this.FindContainerByTagGuid(ViewerDeviceGroupContainerGUIDs.Subnets);
	}

	public get VlanGroupsContainer(): DisplayDeviceGroupContainerDto {
		return this.FindContainerByTagGuid(ViewerDeviceGroupContainerGUIDs.Vlans);
	}

	public FindContainerByGuid(guid: string): DisplayDeviceGroupContainerDto {
		return this.FindContainer((ddgc: DisplayDeviceGroupContainerDto) => {
			return (ddgc.VdgcGuid == guid);
		});
	}

	public FindContainerByTagGuid(tagGuid: string): DisplayDeviceGroupContainerDto {
		return this.FindContainer((ddgc: DisplayDeviceGroupContainerDto) => {
			return (ddgc.VdgcTagGuid == tagGuid);
		});
	}

	public FindGroupByGuid(guid: string): DisplayDeviceGroupDto {
		return this.FindGroup((ddg: DisplayDeviceGroupDto) => {
			return (ddg.VdgGuid == guid);
		});
	}

	public FindGroupByTagGuid(tagGuid: string): DisplayDeviceGroupDto {
		return this.FindGroup((ddg: DisplayDeviceGroupDto) => {
			return (ddg.VdgTagGuid == tagGuid);
		});
	}

	public FindContainer(predicate: (DisplayDeviceGroupContainerDto) => boolean): DisplayDeviceGroupContainerDto {

		if (this.RootContainer) {
			return this._FindContainer(this.RootContainer, predicate);
		}
		else {
			return null;
		}
	}

	public FindGroup(predicate: (DisplayDeviceGroupDto) => boolean): DisplayDeviceGroupDto {

		if (this.RootContainer) {
			return this._FindGroup(this.RootContainer, null, predicate);
		}
		else {
			return null;
		}
	}

	public FindParentGuidOfGroup(ddg: DisplayDeviceGroupDto, currentParent: DisplayDeviceGroupContainerDto | DisplayDeviceGroupDto = this.RootContainer): string {
		let parentGuid = null;
		if (currentParent instanceof DisplayDeviceGroupContainerDto) {
			let containerParent = currentParent as DisplayDeviceGroupContainerDto;
			for (let i = 0; i < containerParent.Containers.Count; ++i) {
				parentGuid = this.FindParentGuidOfGroup(ddg, containerParent.Containers.Get(i));
				if (!!parentGuid) return parentGuid;
			}
			// Check if one of the child groups is the ddg.
			for (let i = 0; i < containerParent.Groups.Count; ++i) {
				let currentGroup = containerParent.Groups.Get(i);
				if (currentGroup.VdgGuid == ddg.VdgGuid) {
					parentGuid = containerParent.VdgcGuid;
					return parentGuid;
				}
				else {
					parentGuid = this.FindParentGuidOfGroup(ddg, currentGroup);
					if (!!parentGuid) return parentGuid;
				}
			}
		}
		else {
			let groupParent = currentParent as DisplayDeviceGroupDto;
			// Check if one of the child groups is the ddg.
			if (groupParent.ChildGroups) {
				for (const currentGroup of groupParent.ChildGroups.ToArray()) {
					if (currentGroup.VdgGuid == ddg.VdgGuid) {
						parentGuid = groupParent.VdgGuid;
						return parentGuid;
					} else {
						parentGuid = this.FindParentGuidOfGroup(ddg, currentGroup);
						if (!!parentGuid) return parentGuid;
					}
				}
			}
		}
		return parentGuid
	}

	public FindTopContainerOfGroup(ddg: DisplayDeviceGroupDto,
		currentParent: DisplayDeviceGroupContainerDto = this.RootContainer): DisplayDeviceGroupContainerDto {

		let result = null;
		for (let i = 0; i < currentParent.Containers.Count; ++i) {
			result = this.FindTopContainerOfGroup(ddg, currentParent.Containers.Get(i));
			if (!!result) {
				return result;
			}
		}

		for (let i = 0; i < currentParent.Groups.Count; ++i) {
			let currentGroup = currentParent.Groups.Get(i);
			if (ddg.VdgGuid === currentGroup.VdgGuid) {
				return currentParent;
			}
			if (this._FindGroupInChildren(ddg, currentGroup)) {
				return currentParent;
			}
		}

		return result;
	}

	private _FindGroupInChildren(group: DisplayDeviceGroupDto, parent: DisplayDeviceGroupDto): boolean {
		for (let i = 0; i < parent.ChildGroups.Count; ++i) {
			let currentGroup = parent.ChildGroups.Get(i);
			if (currentGroup.VdgGuid === group.VdgGuid) {
				return true;
			}
			else {
				if (this._FindGroupInChildren(group, currentGroup)) {
					return true;
				}
			}
		}

		return false;
	}

	private _FindContainer(ddgc: DisplayDeviceGroupContainerDto,
		predicate: (DisplayDeviceGroupContainerDto) => boolean): DisplayDeviceGroupContainerDto {

		if (predicate(ddgc)) {
			return ddgc;
		}

		for (let i = 0; i < ddgc.Containers.Count; ++i) {
			let result = this._FindContainer(ddgc.Containers.Get(i), predicate);
			if (result) {
				return result;
			}
		}

		return null;
	}

	private _FindGroup(ddgc: DisplayDeviceGroupContainerDto, ddg: DisplayDeviceGroupDto,
		predicate: (DisplayDeviceGroupDto) => boolean): DisplayDeviceGroupDto {

		// If the parent is a container:
		if (ddgc) {
			for (let i = 0; i < ddgc.Groups.Count; ++i) {
				let childDdg: DisplayDeviceGroupDto = ddgc.Groups.Get(i);
				let childDdgGuid: string = childDdg.VdgGuid;
				if (predicate(childDdg)) {
					return childDdg;
				}
				if (childDdg.HasChildGroups) {
					let childResult = this._FindGroup(null, childDdg, predicate);
					if (childResult) return childResult;
				}
			}

			for (let i = 0; i < ddgc.Containers.Count; ++i) {
				let result = this._FindGroup(ddgc.Containers.Get(i), null, predicate);
				if (result) {
					return result;
				}
			}

			return null;
		}

		// If the parent is a group:
		else if (ddg) {
			for (let i = 0; i < ddg.ChildGroups.Count; ++i) {
				let childDdg: DisplayDeviceGroupDto = ddg.ChildGroups.Get(i);
				let childDdgGuid: string = childDdg.VdgGuid;
				if (predicate(childDdg)) {
					return childDdg;
				}
				if (childDdg.HasChildGroups) {
					let childResult = this._FindGroup(null, childDdg, predicate);
					if (childResult) return childResult;
				}
			}
		}

		// Both the ddg and ddgc are null which should never happen
		else {
			return null;
		}
	}
}
